import { render, staticRenderFns } from "./qlk-order-integration-resync-btn.vue?vue&type=template&id=4f025d4e"
import script from "./qlk-order-integration-resync-btn.vue?vue&type=script&lang=js"
export * from "./qlk-order-integration-resync-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports